// EcoClub
import React from 'react';
import EcoClub from 'views/EcoClub';

const EcoClubPage = () => {
  return <EcoClub />;
};

export default EcoClubPage;
